import { useMemo } from 'react';

import { GROUP_STATUSES } from '@jebel/constants';

import { ChooseStatusChip, ChooseStatusChipOption } from 'shared/components/ui';

interface Props {
  status: string;
  options?: ChooseStatusChipOption[];
}

const GROUP_STATUS_COLORS = {
  [GROUP_STATUSES.active]: '#01B9A1',
  [GROUP_STATUSES.pending]: '#EF5C5C',
  [GROUP_STATUSES.inactive]: '#616DEE',
  [GROUP_STATUSES.rejected]: '#162D46',
};

const GROUP_STATUS_LABEL = {
  [GROUP_STATUSES.active]: 'Active',
  [GROUP_STATUSES.pending]: 'Pending Approval',
  [GROUP_STATUSES.inactive]: 'Inactive',
  [GROUP_STATUSES.rejected]: 'Rejected',
};

export function ChooseGroupStatusChip(props: Props) {
  const color = useMemo(() => {
    return GROUP_STATUS_COLORS[props.status];
  }, [props.status]);

  const label = useMemo(() => {
    return GROUP_STATUS_LABEL[props.status];
  }, [props.status]);

  return <ChooseStatusChip label={label} color={color} options={props.options} />;
}
